import { h } from "preact";
import { useExternalActionHandler } from "../../../hooks/external-action-handler";
import { useActionEmitter } from "../../../hooks/action-emitter";
import { useRouterActionHandler } from "../../../hooks/router";
import { useAnalytics } from "../../../hooks/analytics";
import { useWalletConfig } from "../../../hooks/client-configurations";
import { useAssetLoader } from "../../../hooks/asset-loader";
import { useClientGuardScreenManager } from "../../../hooks/client-guard-screen-manager";
import ClientGuardRoot1 from "../../routes/client-guard-root-1";

export interface IClientGuardWrapper {
  type_id?: "CLIENT_GUARD_WRAPPER";
  fragment?: {
    rootId: string;
  };
}

export function ClientGuardWrapper(props?: IClientGuardWrapper) {
  const [walletConfig] = useWalletConfig();
  const [rootId, root, selectedFragment] = useClientGuardScreenManager(
    walletConfig,
    props?.fragment
  );
  const [onExternalAction] = useExternalActionHandler();
  const [onRouterAction] = useRouterActionHandler();
  const [onAnalyticsAction] = useAnalytics({
    rootTypeId: root?.type_id,
    rootId: rootId,
  });
  const [status, emit, onAction] = useActionEmitter(
    [onExternalAction, onRouterAction, onAnalyticsAction],
    null
  );

  useAssetLoader(selectedFragment);

  if (root?.type_id === "CLIENT_GUARD_ROOT_1") {
    return (
      <ClientGuardRoot1
        {...root}
        onAction={onAction}
        screen={selectedFragment}
      />
    );
  }
}
